

export default {
  name: 'SubscriptionSelectModal',
  props: {
    value: Boolean
  },
  data () {
    return {
      openPremium: false
    }
  },
  watch: {
    value (newValue) {
      this.openPremium = newValue
    }
  }
}
